export default "__VITE_ASSET__zG44DOqs__"